import WorkerListContainer from "./WorkerList.container";
export default WorkerListContainer;